import { Component, LitElement, property } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';

import { style } from './home.component.css';
import { template } from './home.component.html';

/**
 * @customElement home-component
 */
@Component({
  selector: 'home-component',
  style,
  template,
})
export class HomeComponent extends LitElement {
  @property({ type: Boolean }) showIFrame: boolean;

  @Router() router: Router;
}
